// SVG symbol definitions for stress marks
// Rendered once, referenced via <use> in AccentMark components
// Provides crisp rendering at any zoom level vs text-based Unicode symbols

import { memo } from 'react'

/**
 * StressMarkSymbols - SVG symbol definitions for stress marks
 *
 * Epic 04 Scope 06: SVG-only rendering (feature flag removed)
 * Dimensions from design_tokens.json:
 * - viewBox: 8x10 (8px width × 10px height)
 * - All shapes use filled paths (not strokes) for consistent rendering
 *
 * Shape designs:
 * - Primary (acute ´): Filled parallelogram, thicker at base, slants upper-right
 * - Secondary (grave `): Filled parallelogram, thicker at base, slants upper-left
 * - Unstressed (breve ˘): Filled U-shaped curve (like a shallow bowl)
 *
 * Benefits:
 * - Crisp rendering at any zoom level
 * - Consistent appearance across browsers
 * - Better control over visual design
 * - Single definition, multiple instances (performance)
 * - Filled shapes render more reliably than strokes at small sizes
 */
const StressMarkSymbols = memo(function StressMarkSymbols() {
  return (
    <svg
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
      aria-hidden="true"
    >
      <defs>
        {/* Primary stress - acute accent (´) - filled parallelogram slanting upper-right */}
        <symbol id="stress-mark-primary" viewBox="0 0 8 10">
          <path d="M 2.65,3.82 3.38,0 H 5.8 L 4.5,3.82 Z" fill="currentColor" />
        </symbol>

        {/* Secondary stress - grave accent (`) - filled parallelogram slanting upper-left */}
        <symbol id="stress-mark-secondary" viewBox="0 0 8 10">
          <path d="M 5.48,3.85 4.54,0.03 H 2.12 l 1.3,3.82 z" fill="currentColor" />
        </symbol>

        {/* Unstressed - breve (˘) - filled U-shaped curve */}
        <symbol id="stress-mark-unstressed" viewBox="0 0 8 10">
          <path
            d="M 4,3.62 Q 2.2,3.62 1.09,2.63 0,1.62 0,0 h 1.78 q 0,0.97 0.6,1.57 0.6,0.6 1.59,0.6 Q 5,2.17 5.59,1.57 6.22,0.97 6.22,0 H 8 Q 8,1.62 6.91,2.63 5.8,3.62 4,3.62 Z"
            fill="currentColor"
          />
        </symbol>
      </defs>
    </svg>
  )
})

export default StressMarkSymbols
